module.exports = __webpack_public_path__ + "assets/word_flow.59481e25.svg";